
(() => {

  const isHome =
    document.body.classList.contains('index-template') ||
    document.body.classList.contains('template-index') ||
    document.body.classList.contains('page-index') ||
    document.body.dataset?.template === 'index';

  if (!isHome) return;

  const $ = (sel, root = document) => root.querySelector(sel);
  if (!window.location.pathname.startsWith('/collections/all')) {
  sessionStorage.removeItem('fenix_ymm');
}

  function dispatchChange(el) {
    if (!el) return;
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getAlphaParts(alphaRoot) {

    const a1 = $('.js-filter-select-1', alphaRoot);
    const a2 = $('.js-filter-select-2', alphaRoot);
    const a3 = $('.js-filter-select-3', alphaRoot);
    const submit = $('.js-filter-submit', alphaRoot);

    const n1 = a1?.parentElement?.querySelector('.nice-select.js-filter-select-1');
    const n2 = a2?.parentElement?.querySelector('.nice-select.js-filter-select-2');
    const n3 = a3?.parentElement?.querySelector('.nice-select.js-filter-select-3');

    return { a1, a2, a3, n1, n2, n3, submit };

  }

  function getEasyParts(easyRoot) {

    const e1 = $('#easysearch_field_34242', easyRoot);
    const e2 = $('#easysearch_field_34243', easyRoot);
    const e3 = $('#easysearch_field_34241', easyRoot);
    const search = $('#easysearch-search', easyRoot);

    return { e1, e2, e3, search };

  }

  function setNiceDisabled(niceEl, disabled) {

    if (!niceEl) return;

    niceEl.classList.toggle('disabled', !!disabled);

    if (disabled) {
      niceEl.setAttribute('aria-disabled', 'true');
      niceEl.setAttribute('tabindex', '-1');
    } else {
      niceEl.setAttribute('aria-disabled', 'false');
      niceEl.setAttribute('tabindex', '0');
    }

  }

  function rebuildNiceList(selectEl, niceEl) {

    if (!selectEl || !niceEl) return;

    const currentSpan = niceEl.querySelector('.current');
    const ul = niceEl.querySelector('ul.nice-list');
    if (!ul) return;

    const selectedOpt = selectEl.selectedOptions?.[0];
    const selectedText = selectedOpt ? selectedOpt.textContent : '';

    if (currentSpan)
      currentSpan.textContent =
        selectedText || selectEl.options?.[0]?.textContent || '';

    ul.querySelectorAll('li.option').forEach((li) => li.remove());

    [...selectEl.options].forEach((opt) => {

      const li = document.createElement('li');

      li.className = 'option';
      li.dataset.value = opt.value;

      if (!opt.value) li.classList.add('null');
      if (opt.selected) li.classList.add('selected');

      li.textContent = opt.textContent || '';

      ul.appendChild(li);

    });

  }

  function syncAlphaFromEasy(alphaSelect, alphaNice, easySelect) {

    if (!alphaSelect || !easySelect) return;

    const placeholder = alphaSelect.options?.[0]?.cloneNode(true) || null;
    const keepPlaceholderText = placeholder?.textContent || '';

    alphaSelect.innerHTML = '';

    if (placeholder) {

      placeholder.selected = !easySelect.value;
      alphaSelect.appendChild(placeholder);

    } else {

      const ph = document.createElement('option');
      ph.value = '';
      ph.textContent = keepPlaceholderText || 'Select';
      ph.selected = !easySelect.value;

      alphaSelect.appendChild(ph);

    }

    [...easySelect.options].forEach((opt) => {

      if (!opt.value) return;

      const o = document.createElement('option');

      o.value = opt.value;
      o.textContent = opt.textContent || opt.value;
      o.selected = opt.value === easySelect.value;

      alphaSelect.appendChild(o);

    });

    alphaSelect.disabled = !!easySelect.disabled;

    setNiceDisabled(alphaNice, alphaSelect.disabled);

    rebuildNiceList(alphaSelect, alphaNice);

  }

  function bindNiceClickToSelect(alphaSelect, alphaNice) {

    if (!alphaSelect || !alphaNice) return;

    alphaNice.addEventListener('click', (e) => {

      const li = e.target?.closest?.('li.option');
      if (!li) return;

      if (alphaSelect.disabled || alphaNice.classList.contains('disabled'))
        return;

      const value = li.dataset.value ?? '';

      alphaSelect.value = value;

      alphaNice
        .querySelectorAll('li.option.selected')
        .forEach((n) => n.classList.remove('selected'));

      li.classList.add('selected');

      const currentSpan = alphaNice.querySelector('.current');

      if (currentSpan)
        currentSpan.textContent = li.textContent || '';

      dispatchChange(alphaSelect);

    });

  }

  function observeSelectChanges(selectEl, onChange) {

    if (!selectEl) return;

    const mo = new MutationObserver(() => onChange());

    mo.observe(selectEl, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });

    selectEl.addEventListener('change', onChange);

    return mo;

  }

  function observeSearchLink(linkEl, onChange) {

    if (!linkEl) return;

    const mo = new MutationObserver(() => onChange());

    mo.observe(linkEl, {
      attributes: true,
      attributeFilter: ['aria-disabled', 'href', 'disabled'],
    });

    return mo;

  }

  function init() {

    const alphaRoot = $('quick-filter');
    const easyRoot = $('.easysearch-main-holder');

    if (!alphaRoot || !easyRoot) return;

    const easyContainer =
      easyRoot.closest('.easysearch-block-container') || easyRoot;

    easyContainer.classList.add('es-bridge-hidden');

    const alpha = getAlphaParts(alphaRoot);
    const easy = getEasyParts(easyRoot);

    if (!alpha.a1 || !alpha.a2 || !alpha.a3 || !alpha.submit) return;
    if (!easy.e1 || !easy.e2 || !easy.e3 || !easy.search) return;

    syncAlphaFromEasy(alpha.a1, alpha.n1, easy.e1);
    syncAlphaFromEasy(alpha.a2, alpha.n2, easy.e2);
    syncAlphaFromEasy(alpha.a3, alpha.n3, easy.e3);

    bindNiceClickToSelect(alpha.a1, alpha.n1);
    bindNiceClickToSelect(alpha.a2, alpha.n2);
    bindNiceClickToSelect(alpha.a3, alpha.n3);

    alpha.a1.addEventListener('change', () => {

  sessionStorage.removeItem('fenix_ymm');

  easy.e1.value = alpha.a1.value || '';
  dispatchChange(easy.e1);

});

    alpha.a2.addEventListener('change', () => {

      easy.e2.value = alpha.a2.value || '';
      dispatchChange(easy.e2);

    });

    alpha.a3.addEventListener('change', () => {

      easy.e3.value = alpha.a3.value || '';
      dispatchChange(easy.e3);

    });

    observeSelectChanges(easy.e1, () => {
      syncAlphaFromEasy(alpha.a1, alpha.n1, easy.e1);
    });

    observeSelectChanges(easy.e2, () => {
      syncAlphaFromEasy(alpha.a2, alpha.n2, easy.e2);
    });

    observeSelectChanges(easy.e3, () => {
      syncAlphaFromEasy(alpha.a3, alpha.n3, easy.e3);
    });

    const syncSubmitState = () => {

      const ariaDisabled = easy.search.getAttribute('aria-disabled');

      const isDisabled =
        ariaDisabled === 'true' ||
        ariaDisabled === '1' ||
        easy.search.hasAttribute('disabled');

      alpha.submit.disabled = !!isDisabled;
      alpha.submit.setAttribute('aria-disabled', String(!!isDisabled));

    };

    syncSubmitState();
    observeSearchLink(easy.search, syncSubmitState);

    alpha.submit.addEventListener(

  'click',

  (e) => {

    e.preventDefault();
    e.stopPropagation();

    syncSubmitState();

    if (alpha.submit.disabled) return;

    const make = alpha.a1?.value || '';
    const model = alpha.a2?.value || '';
    const year = alpha.a3?.value || '';

    if (make && model && year) {
      sessionStorage.setItem('fenix_ymm', `${make}-${model}-${year}`);
    }

    easy.search.click();

  },

  true

);

  }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }

})();
